// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import {ScaleLinear} from 'd3';
import $ from 'jquery';
import _ from 'underscore';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MenuChoicesOptions} from 'components/SelectionContextMenuHelpers';
import {Sequence} from 'components/Sequence';
import * as MapsConstants from 'constants/MapsConstants';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import {AaSequenceAnnotationView} from 'molbio/aa-sequences/AaSequenceAnnotationsView';
import * as ProteinContextMenus from 'molbio/aa-sequences/AaSequenceContextMenus';
import Component, {ComponentOptions} from 'molbio/maps/linear/Component';
import {
  getLayersDict,
  LayersDict,
  span,
  timesPerSlice,
  whichDisplay,
} from 'molbio/maps/linear/LayeringHelpers';
import {LayeredLayout} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';
import {SliceView} from 'molbio/maps/linear/SliceView';
import {RegionSelectable} from 'molbio/maps/selectables/Selectables';

type WithColor<M> = M & {color(): string};

export interface LayeredViewOptions extends ComponentOptions {
  slice: Slice;
  parent: SliceView;
}

/**
 * LayeredView is an abstract base class that handles rendering features that span a range of residues.
 *
 * This class should not assume sequence is a Backbone model... but does inspect the object for rendering
 * the appropriate right click menu. `getPolymerLength` assumes that `sequence` is a Sequence / Protein
 * model, but this can be overridden in a subclass that does not have a `sequence` Backbone model.
 */
export default abstract class LayeredView<
  Polymer extends Sequence | AaSequence,
  Datum extends RegionSelectable<Polymer>,
> extends Component {
  sequence!: Polymer;
  data!: Array<Datum>;
  max!: number;
  layersDict!: LayersDict;
  slice!: Slice;
  parent!: SliceView;

  abstract makeLayerPiece(enter: d3.Selection<SVGElement, Datum, d3.BaseType, unknown>): void;
  abstract rerenderSingle(
    el: SVGElement,
    start: number,
    end: number,
    dx: number,
    dy: number,
    d: Datum,
    xx: number,
    yy: number,
    x: ScaleLinear<number, number>,
    y: ScaleLinear<number, number>,
    i: number
  ): void;

  getData(start?: number, end?: number): Array<Datum> {
    return [];
  }

  // Seemingly unused.
  singleName(): 'layer' {
    return 'layer';
  }

  getLayout(): LayeredLayout {
    // @ts-expect-error: child classes are expected to override this
    return null;
  }

  layeringMode(): MapsConstants.LayeringMode {
    return MapsConstants.LINEAR_LAYER_FULL;
  }

  isShown(): boolean | null {
    return null;
  }

  override initialize(options: LayeredViewOptions): void {
    super.initialize(options);
    this.slice = options.slice;
    this.parent = options.parent;
    this.sequence = this.model.get('sequence');
    this.max = 0;
  }

  override registerListeners(): void {
    super.registerListeners();
    this.$el.on('focus', (e) => {
      // In order to preserve the correct selection states, do not fire a focus event on the clicked element
      // and keep the focus on the clicked buffer tab.
      $(e.target).closest('.buffer-tab, .alignment-row').focus();
    });
  }

  getPolymerLength(): number {
    return this.sequence.length();
  }

  layerFill(this: LayeredView<Polymer, WithColor<Datum>>, d: WithColor<Datum>): string {
    return d.color();
  }

  layerFillOpacity(d: Datum): number {
    if (d.get('hover') || d.selected()) {
      return 1.0;
    } else {
      return 0.7;
    }
  }

  // Can be overridden in subclasses to customize outline color
  outlineColor(this: LayeredView<Polymer, WithColor<Datum>>, d: WithColor<Datum>): string {
    if (d.selected()) {
      return '#111';
    } else {
      return d3.rgb(d.color()).darker().formatHex();
    }
  }

  handleHoverSelect(
    this: LayeredView<Polymer, WithColor<Datum>>,
    model: WithColor<Datum>,
    value: unknown
  ): void {
    const id = model.uid();
    const root = d3.select(this.el).select('g').selectAll('g').filter(`[id='${id}-0'],[id='${id}-1']`);
    root.select('text').attr('font-weight', (d: Datum) => {
      if (d.selected()) {
        return 'bold';
      } else {
        return 'normal';
      }
    });
    root
      .selectAll('.layer-fill')
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill-opacity', this.layerFillOpacity)
      .attr('fill', (d: WithColor<Datum>) => this.layerFill(d));
    root.selectAll('.stroked').attr('stroke', (d: WithColor<Datum>) => this.outlineColor(d));
  }

  override die(): void {
    super.die();
    this.killTooltips();
  }

  killTooltips(): void {
    const root = d3.select(this.el).select('g').selectAll<SVGGElement, Datum>('g');
    root.on('.layeredview', null).each(function () {
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      return $(this).tooltip('destroy');
    });
  }

  override boxHeight(): number {
    if (this.isShown()) {
      return this.getLayout().boxHeight({overlap: this.max, ...this.getAdditionalHeightOptions()});
    } else {
      return 0;
    }
  }

  maxOverlap(start: number, end: number): number {
    let ends: Array<[number, number]> = [];
    for (const model of Array.from(this.data)) {
      const modelSpan = span(
        start,
        end,
        model.drawStart(this.sequence),
        model.drawEnd(this.sequence),
        this.getPolymerLength()
      )!;
      ends.push([Math.max(modelSpan.start, start) - start, 1]);
      ends.push([Math.min(modelSpan.end, end) - start - 1, -1]);
    }

    ends = _.sortBy(
      _.sortBy(ends, (e) => -1 * e[1]),
      (e) => e[0]
    );

    let max = 0;
    let current = 0;
    // @ts-expect-error: shadowing method param :cry:
    for (end of Array.from(ends)) {
      // @ts-expect-error: shadowing method param :cry:
      current += end[1];
      if (current > max) {
        max = current;
      }
    }
    return max;
  }

  updateLayerPiece(
    root: d3.Selection<SVGGElement, Datum, SVGGElement, unknown>,
    x: ScaleLinear<number, number>,
    y: ScaleLinear<number, number>
  ): void {
    const {sequence} = this;
    const {layersDict} = this;
    const layeringMode = this.layeringMode();
    const polymerLength = this.getPolymerLength();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return (function (ref: LayeredView<Polymer, Datum>, layout: LayeredLayout, slice: Slice): void {
      root
        .on(
          'mousedown.layeredview',
          // eslint-disable-next-line no-restricted-syntax
          _.bind(function (this: LayeredView<Polymer, Datum>, e: MouseEvent, d: Datum, i: number) {
            e.stopPropagation();
            // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
            return this.pieceClickHandler(e, d);
          }, ref)
        )
        .on(
          'dblclick.layeredview',
          // eslint-disable-next-line no-restricted-syntax
          _.bind(function (this: LayeredView<Polymer, Datum>, e: MouseEvent, d: Datum) {
            e.stopPropagation();
            // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
            return this.pieceDblClickHandler(e, d);
          }, ref)
        )
        .on('mouseover.layeredview', (e, d: Datum) => d.set({hover: true}))
        .on('mouseout.layeredview', (e, d: Datum) => d.set({hover: false}))
        .attr('id', (d: Datum, i: number): string => `${d.uid()}-${i}`)
        .on('contextmenu.layeredview', (e: MouseEvent, d: Datum): void => {
          let contextMenuData;
          ref.pieceClickHandler(e, d);
          if (sequence instanceof AaSequence) {
            contextMenuData = ref.contextMenuData(d);
            if (contextMenuData.annotation != null) {
              ProteinContextMenus.openAnnotationContextMenu(
                e,
                sequence,
                contextMenuData.annotation as unknown as AaSequenceAnnotationView
              );
            } else {
              ProteinContextMenus.openSelectionContextMenu(e, sequence);
            }
            // guard against null sequence values in the case of Protein Alignment Annotations
          } else if (sequence) {
            // the arg names are confusing here, contextMenuData is an object containing options data
            // for the context menu. contextMenuOptions are the actual menu items to display
            selectioncontextmenu.open(e, sequence, ref.contextMenuOptions(), ref.contextMenuData(d));
          }
        });
      root.each(function (d: Datum, i: number) {
        const {start, end} = whichDisplay(
          slice.start(),
          slice.end(),
          d.drawStart(sequence),
          d.drawEnd(sequence),
          i,
          polymerLength
        )!;
        const xx = x(start);
        const yy = y(layersDict[d.get(layeringMode)]);
        const dx = x(end) - x(start);
        const dy = layout.singleHeight(ref.getAdditionalHeightOptions());

        d3.select(this).attr('transform', `translate(${xx}, ${yy})`);
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return ref.rerenderSingle(this, start, end, dx, dy, d, xx, yy, x, y, i);
      });
    })(this, this.getLayout(), this.slice);
  }

  setLayersDict(): LayersDict {
    this.layersDict = getLayersDict(this.data, this.layeringMode());
    this.max = Object.keys(this.layersDict).length;
    return this.layersDict;
  }

  override prepareHeight(): LayersDict {
    this.setData();
    return this.setLayersDict();
  }

  setData(start?: number, end?: number): void {
    this.data = this.getData(start, end);
  }

  /*
  Provide subclasses a way to specify slice-specific data that can affect height
   */
  getAdditionalHeightOptions(): {} {
    return {};
  }

  update(trigger?: boolean): void {
    if (trigger == null) {
      trigger = true;
    }

    if (!this.isShown()) {
      return;
    }
    const start = this.slice.start();
    const end = this.slice.end();
    this.setData(start, end);
    this.setLayersDict();

    const x = this.slice.x(); // function to determine where the view should start on the left-right axis
    const y: ScaleLinear<number, number> = d3
      .scaleLinear()
      .domain([0, this.max !== 1 ? this.max - 1 : 1]) // never have a domain of [0, 0], it results in undefined behavior in d3
      .range([0, this.getLayout().height({overlap: this.max - 1, ...this.getAdditionalHeightOptions()})]);

    const base = d3.select(this.el).selectAll('.component-wrapper');

    // add elements for new layers
    const root = base
      .selectAll<SVGGElement, Datum>('.layer-group')
      .data(this.data)
      .join('g')
      .classed('layer-group', true);

    // remove elements for old layers
    root
      .exit()
      .each(function () {
        return d3
          .select(this)
          .selectAll<SVGGElement, Datum>('.layer')
          .each(function () {
            // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
            return $(this).tooltip('destroy');
          });
      })
      .remove(); // kill tool tips

    const singlePieces = root
      .selectAll<SVGGElement, Datum>('.layer')
      .data((d) => timesPerSlice(d, start, end, d.drawStart(this.sequence), d.drawEnd(this.sequence)))
      .join('g')
      .classed('layer', true);

    this.makeLayerPiece(singlePieces);

    singlePieces
      .exit()
      .each(function (d: Datum) {
        // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
        return $(this).tooltip('destroy');
      })
      .remove();

    this.updateLayerPiece(singlePieces, x, y);

    if (trigger) {
      this.trigger('redraw');
    }
  }

  contextMenuOptions(): Array<string> {
    return [];
  }

  contextMenuData(d?: Datum): MenuChoicesOptions {
    return {};
  }
}
